import core from '@gin-betting/core';
import { useCallback, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { OrderedSet } from 'immutable';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { State } from 'types';
import { DEFAULT_TOURNAMENTS_SIZE } from '../../../constants';
import { getTopTournaments } from '../../../actions';
import { selectExistedTopTournamentIds } from '../../../selectors';
import { getTopTournamentsVars } from '../../../utils';

const {
    poller: { usePoller },
    utils: { getSportTypeFromLocation },
} = core;

const selectProps = createStructuredSelector({
    topTournamentIds: selectExistedTopTournamentIds,
});

interface Output {
    topTournamentIds: OrderedSet<string>;
    toggleExpand: () => void;
    isExpanded: boolean;
    isShowExpandButton: boolean;
}

function useTopTournamentList(): Output {
    useLocation();
    const sportType = getSportTypeFromLocation();

    const { topTournamentIds } = useSelector((state: State) =>
        selectProps(state, {})
    );
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const resultTournaments = isExpanded
        ? topTournamentIds
        : topTournamentIds.slice(0, DEFAULT_TOURNAMENTS_SIZE);

    const toggleExpand = useCallback(() => setIsExpanded(!isExpanded), [
        isExpanded,
    ]);
    const isShowExpandButton = topTournamentIds.size > DEFAULT_TOURNAMENTS_SIZE;

    usePoller({
        pollerName: 'TOP_TOURNAMENTS',
        executableAction: getTopTournaments,
        variables: getTopTournamentsVars(sportType),
        isPollingTurnedOff: false,
    });

    return {
        topTournamentIds: resultTournaments,
        toggleExpand,
        isExpanded,
        isShowExpandButton,
    };
}

export default useTopTournamentList;
